/**
 * Converts pixels to rem units based on a given base font size.
 * @param pixels - The number of pixels to convert.
 * @param baseFontSize - The base font size in pixels. Default is 16 pixels.
 * @returns The converted value in rem units.
 */
export function rem(pixels: number, baseFontSize: number = 16): string {
  return `${pixels / baseFontSize}rem`;
}
